<app-modal class="density-lower"
  title="Aviso"
  [attr.data-cy]="getDataCy('modal-message-container')">

  <div class="modal-content" [attr.data-cy]="getDataCy('modal-message-content')">
    <span class="message" [attr.data-cy]="getDataCy('modal-message-confirm-message')"> {{message}} </span>
  </div>

  <div class="modal-bottom" [attr.data-cy]="getDataCy('modal-message-bottom')">
    <app-button [attr.data-cy]="getDataCy('modal-message-' + txtBtnClose)" (onClick)="onClose(true)" color="primary">
      <span class="button-label">{{txtBtnClose}}</span>
    </app-button>
  </div>
</app-modal>
